import React from "react";

const Pagination = ({ t, pageNumber,totalPages,hasNextPage,hasPreviousPage, onPageChange }) => {
  // Generate page numbers dynamically with ellipsis if too many pages
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 7;
    let startPage = Math.max(1, pageNumber - 3);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <section className="section-pagination">
      {/* Back button */}
      <div
        className={`btn-back flex-center ${!hasPreviousPage ? "disabled" : ""}`}
        onClick={() => hasPreviousPage && onPageChange(pageNumber - 1)}
      >
        <span>{t("back")}</span>
        <i className="fas fa-chevron-left"></i>
      </div>

      {/* Page numbers */}
      <ul className="pagination-list">
        {pageNumbers[0] > 1 && <li onClick={() => onPageChange(1)}>1</li>}
        {pageNumbers[0] > 2 && <li>...</li>}

        {pageNumbers.map((page) => (
          <li
            key={page}
            className={page === pageNumber ? "active-page" : ""}
            onClick={() => onPageChange(page)}
          >
            {page}
          </li>
        ))}

        {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && <li>...</li>}
        {pageNumbers[pageNumbers.length - 1] < totalPages && <li  onClick={() => onPageChange(totalPages)}>{totalPages}</li>}
      </ul>

      {/* Next button */}
      <div
        className={`btn-next flex-center ${!hasNextPage ? "disabled" : ""}`}
        onClick={() => hasNextPage && onPageChange(pageNumber + 1)}
      >
        <i className="fas fa-chevron-right"></i>
        <span>{t("next")}</span>
      </div>
    </section>
  );
};

export default Pagination;